import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-94b6e4ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("กรุณาตรวจสอบก่อนใช้งาน ")
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode(",และทำความเข้าใจข้อมูล/คำขออนุญาตต่อไปนี้อย่างถ่องแท้: ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "เพื่อให้บริการแก่คุณ เราจะยื่นขอสิทธิ์เครือข่าย ที่เก็บข้อมูล และการระบุอุปกรณ์กับคุณ และคุณมีสิทธิ์ที่จะปฏิเสธหรือยกเลิกการอนุญาตข้อมูล/การอนุญาตที่กล่าวถึงข้างต้นในการตั้งค่าระบบได้ตลอดเวลา ", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_dialog = _resolveComponent("van-dialog")!

  return (_openBlock(), _createBlock(_component_van_dialog, {
    show: $setup.show,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (($setup.show) = $event)),
    title: "ขอบคุณที่ใช้แอพนี้",
    "show-cancel-button": "",
    onConfirm: _cache[1] || (_cache[1] = ($event: any) => ($setup.ok()))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _hoisted_2,
          _createElementVNode("a", {
            class: "xieyi",
            target: "_blank",
            href: $setup.getxy()
          }, _toDisplayString(_ctx.$t('me.rjfwyx')), 9 /* TEXT, PROPS */, _hoisted_3),
          _hoisted_4
        ]),
        _hoisted_5
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show"]))
}